import React from 'react';
import styles from './Spinner.sass';

export default (props) =>
    <div className={styles.root + ' ' + props.className + ' ' + (props.stopped ? 'stopped' : null)}>
        <div/>
        <div/>
    </div>



// WEBPACK FOOTER //
// ./src/elements/Spinner/Spinner.js